<template>
  <v-dialog
    v-model="isVisible"
    max-width="1200"
    width="80vw"
  >
    <v-card>
      <v-card-title>
        Quick Interviews for {{ peParty.first_name }} {{ peParty.last_name }}
      </v-card-title>
      <v-divider />
      <v-data-table
        fixed-header
        :headers="headers"
        height="530"
        :items="rows"
        :loading="isLoading"
        sort-by="createdDate"
        sort-desc
      >
        <template #[`item.createdDate`]="{ item }">
          {{ item.createdDate | formatDateTime }}
        </template>
        <template #[`item.status`]="{ item }">
          <v-chip
            :color="item.status.color"
            :dark="item.status.dark"
            small
          >
            {{ item.status.description }}
          </v-chip>
        </template>
        <template #[`item.statusDate`]="{ item }">
          {{ item.statusDate | formatDateTime }}
        </template>
        <template #[`item.actions`]="{ item }">
          <ViewQuickInterviewChangesIconButton
            v-if="false"
            :interview-id="item.id"
          />
          <CloseQuickInterviewIconButton
            :interview-id="item.id"
          />
        </template>
      </v-data-table>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          depressed
          @click="isVisible = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { alertHandler } from '@/alertHandler'
import { parseErrorResponse } from '@/utilities/error-responses'
import { quickInterviewStatusDetails } from '@/store/quick-interview/state'

import { PARTY_NAMESPACE } from '@/store/party'
import { QUICK_INTERVIEW_NAMESPACE } from '@/store/quick-interview'

import CloseQuickInterviewIconButton from './ActionButtons/CloseQuickInterviewIconButton.vue'
import ViewQuickInterviewChangesIconButton from './ActionButtons/ViewQuickInterviewChangesIconButton.vue'

export default {
  name: 'QuickInterviewsListDialog',

  components: {
    CloseQuickInterviewIconButton,
    ViewQuickInterviewChangesIconButton,
  },

  model: {
    prop: 'visible',
    event: 'change',
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  setup () {
    return {
      ...alertHandler(),
    }
  },

  data () {
    return {
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Created', value: 'createdDate' },
        { text: 'Interviewer', value: 'interviewerName' },
        { text: 'Status', value: 'status' },
        { text: 'Status Date', value: 'statusDate' },
        { text: 'Last Step', value: 'lastStepTitle' },
        { text: 'Suggested Legal Cases', value: 'suggestedLegalCases' },
        { align: 'end', sortable: false, text: 'Actions', value: 'actions' },
      ],

      isLoading: true,
      isQuickInterviewWizardOpen: false,
    }
  },

  computed: {
    allUsersOptions () {
      return this.usersOptions({ includeAll: true })
    },

    isVisible: {
      get () { return this.visible },
      set (value) { this.$emit('change', value) },
    },

    rows () {
      if (this.isLoading) return []

      return this.quickInterviewsList.map(entry => {
        return {
          action: '',
          createdDate: entry.created_at,
          id: entry.id,
          interviewerName: this.allUsersOptions.find(u => u.value === entry.user_id)?.displayName,
          lastStepTitle: entry.last_step_title,
          status: quickInterviewStatusDetails[entry.status],
          statusDate: entry.status_date,
          suggestedLegalCases: (Array.isArray(entry.steps_data)
            ? entry.steps_data.find(step => step.component === 'SuggestLegalCasesStep')?.data
            : entry.steps_data
          )?.suggested_legal_case_types?.join(', '),
        }
      })
    },

    ...mapGetters([
      'usersOptions',
    ]),

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),

    ...mapGetters(QUICK_INTERVIEW_NAMESPACE, [
      'quickInterviewsList',
    ]),
  },

  watch: {
    visible: {
      handler: function (value) { if (value) this.loadData() },
      immediate: true,
    },
  },

  methods: {
    async loadData () {
      this.isLoading = true

      if (!this.allUsersOptions || !this.allUsersOptions.length) { await this.getUsersModel() }

      this.listQuickInterviews({ party_id: this.peParty.id }).
        catch(e => this.displayAlert('error', parseErrorResponse(e))).
        finally(_ => { this.isLoading = false })
    },

    ...mapActions([
      'getUsersModel',
    ]),

    ...mapActions(QUICK_INTERVIEW_NAMESPACE, [
      'listQuickInterviews',
    ]),
  },
}
</script>
